<template>
  <div class="navbar">
    <div class="header" :class="props.onHomePage ? 'color-light' : 'color-dark'">
      <!-- Logo -->
      <div>
        <router-link to="/">
          <img class="header-logo" src="/images/blasio_logo2.svg" alt="Blasio design építésziroda logoja"
            :class="props.onHomePage ? 'fill-light' : 'fill-dark'" />
        </router-link>
      </div>

      <!-- Routes -->
      <div class="routes">
        <ul>
          
          <li>
            <router-link to="/" :class="props.onHomePage ? 'color-light' : 'color-dark'">{{ $t('header.routes.home')
            }}</router-link>
          </li>

          <li>
            <router-link to="/about" :class="props.onHomePage ? 'color-light' : 'color-dark'">{{
              $t('header.routes.about') }}</router-link>
          </li>
          
          <li>
            <router-link to="/portfolio" :class="[
              props.onHomePage ? 'color-light' : 'color-dark',
              { active: $route.path.startsWith('/portfolio') }
            ]">
              {{ $t('header.routes.portfolio') }}
            </router-link>
          </li>
          
          <li>
            <router-link to="/team" :class="props.onHomePage ? 'color-light' : 'color-dark'">{{ $t('header.routes.team')
            }}</router-link>
          </li>

          <li>
            <router-link to="/contact" :class="props.onHomePage ? 'color-light' : 'color-dark'">{{
              $t('header.routes.contact') }}</router-link>
          </li>
        </ul>
      </div>

      <!-- Icons -->
      <div class="header-icons">
        <a href="https://epiteszforum.hu/" target="_blank">
          <img class="header-icon" :class="props.onHomePage ? 'fill-light' : 'fill-dark'"
            src="/images/icons/epforum.svg" alt="Blasio design építészfórum oldala" />
        </a>
        <a href="https://www.instagram.com/" target="_blank">
          <img class="header-icon" :class="props.onHomePage ? 'fill-light' : 'fill-dark'"
            src="/images/icons/instagram.svg" alt="Blasio design instagram oldala" />
        </a>
        <a href="https://www.facebook.com/" target="_blank">
          <img class="header-icon" :class="props.onHomePage ? 'fill-light' : 'fill-dark'"
            src="/images/icons/facebook.svg" alt="Blasio design facebook oldala" />
        </a>
        <h6 class="lang" @click="setLang('hu')">HU</h6>
        <h6 class="lang" @click="setLang('en')">EN</h6>
      </div>

      <!-- Sidebar -->
      <div class="sidebar">
        <SideBar :onHomePage="props.onHomePage" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import SideBar from "../SideBar.vue";

const { locale } = useI18n();

const props = defineProps({
  onHomePage: {
    type: Boolean,
    default: false
  }
});

const setLang = (newLang) => {
  locale.value = newLang;
  localStorage.setItem("lang", newLang);
};

const savedLang = localStorage.getItem("lang");
if (savedLang) {
  locale.value = savedLang;
}
</script>

<style lang="css" scoped>
.navbar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  /* background-color: #282828; */
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 100px;
  /* color: #f5f5f5; */
  z-index: 100;
  height: 80px;
}

.header .header-logo {
  width: 80px;
}

.routes {
  display: flex;
  justify-content: center;
  align-items: center;
}

.routes ul {
  display: flex;
  justify-content: center;
  align-items: center;
  list-style: none;
  gap: 80px;
  padding: 0;
  margin: auto;
}

.routes ul li a {
  text-decoration: none;
  /* color: #f5f5f5; */
  font-size: 16px;
  transition: font-weight 200ms ease-in-out;
}

.routes ul li a:hover {
  font-weight: 500;
  transition: ease-in-out 200ms;
}


.routes ul li a.router-link-active {
  font-weight: 500;
}

.active {
  font-weight: 500;
}

.header-icons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  height: auto;
}

.header-icons a {
  width: 25px;
  height: 25px;
}

.header-icon {
  width: 25px;
  height: 25px;
  cursor: pointer;
  margin: 0;
}

.lang {
  cursor: pointer;
  font-size: 16px;
  margin: 0;
  text-transform: uppercase;
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+/Edge */
  user-select: none;
  /* Standard */
}

.sidebar {
  display: none;
  cursor: pointer;
}

@media only screen and (max-width: 1300px) {
  .routes ul {
    gap: 60px;
  }

  .routes ul li a,
  .lang {
    font-size: 14px;
  }

  .header-icons a {
    width: 20px;
    height: 20px;
  }

  .header-icon {
    width: 20px;
    height: 20px;
  }

}

@media only screen and (max-width: 1140px) {
  .routes ul {
    gap: 40px;
  }

  .routes ul li a {
    font-size: 14px;
  }

  .header-icons {
    gap: 16px;
  }
}

@media only screen and (max-width: 1040px) {
  .header {
    padding: 0 80px;
  }

  .routes ul {
    gap: 30px;
  }

  .routes ul li a {
    font-size: 12px;
  }

  .header-icons {
    gap: 14px;
  }

}

@media only screen and (max-width: 891px) {

  .sidebar {
    display: block;
    height: 30px;
  }

  .routes,
  .header-icons,
  .header-icon,
  .lang {
    display: none;
  }
}
</style>
